import { render } from "./CompanyComponent.vue?vue&type=template&id=7d76897b&ts=true"
import script from "../Company/Company.Service.ts?vue&type=script&lang=ts&external"
export * from "../Company/Company.Service.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__